import { createFileRoute } from '@tanstack/react-router';
import SEO from 'components/Seo/Seo';
import { useSelector } from 'react-redux';
import { RootState } from 'store/reducer';
import messages from '../../../messages';
import BankDepositComponent from './components/BankDeposit';
import { requireVerified } from 'utils/verification-guard';

export const Route = createFileRoute('/_authenticated/funds/deposit/fiat/bank/')({
  beforeLoad: requireVerified,
  component: BankDeposit,
});

function BankDeposit() {
  const { language } = useSelector(
    (rootState: RootState) => rootState.language,
  );

  const fundsMessages = messages[language].seo;

  return (
    <>
      <SEO
        title={fundsMessages.title}
        description={fundsMessages.description}
        keywords={fundsMessages.keywords}
        page={`/funds/deposit/fiat/bank/`}
      />
      <div className="px-6 py-4">
        <BankDepositComponent />
      </div>
    </>
  );
}
